import React from 'react';
const WebformDebug = ({ element, error }) => (<code>
		{error}
		<pre>{JSON.stringify(element, null, 2)}</pre>
	</code>);
export default WebformDebug;
//# sourceMappingURL=WebformDebug.jsx.map